import { ImageUploadCard } from 'components/ImageUploadCard'
import Input from 'components/form/Input'
import TextArea from 'components/form/TextArea'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { cloneDeep, isEmpty } from 'lodash'
import { isObjectEmpty } from 'helpers/objectHelper'
import { useDispatch, useSelector } from 'react-redux'
import { RadioGroup, RadioItem } from 'components/form/RadioGroup'
import LabeledSelect from 'components/selects/LabeledSelect'
import FormLabel from 'components/form/FormLabel'
import {
  getFormattedSeoUrl,
  getReverseFormattedSeoUrl,
} from 'helpers/seoHelper'
import {
  categoryOptions,
  groupOptions,
  notificationTypeOptions,
  productListType,
  typeOptions,
  initialNotification,
  filterTypes,
  initialAge,
  notificationGroup,
  bulkNotificationTypeOptions,
  userGroup,
  smsCharacterLimit,
} from '../constants'
import { DateTimePicker } from '../../../components/datepicker/DatePicker'
import ProductSelector from './ProductSelector'
import Chip from '../../../components/form/Chip'
import ProductViewer from './ProductPreviewViewer'
import CustomCard from '../../../components/card/CustomCard'
import CardBody from '../../../components/card/CardBody'
import CustomCardHeader from '../../../components/card/CustomCardHeader'
import UserInfoSearchSelect from 'pages/nuseCampaign/components/SearchBar'
import CustomButton, { SecondaryButton } from '../../../components/CustomButton'
import NotificationSelects from './NotificationSelectsInput'
import {
  broadcastNotification,
  tryScheduleNotification,
  tryUpdateScheduleNotification,
} from 'redux/slices/notificationSlice'
import { removeKeysFromObjectWithEmptyOrNullOrUndefinedValue } from 'helpers/objectHelper'
import { capitalizeAndRemoveUnderscore } from 'helpers/stringHelper'
import { isNotEmpty } from 'helpers/stringHelper'
import { capitalizeFirstLetter } from 'helpers/stringHelper'
import TabGroup from 'components/tab/TabGroup'
import CustomTab from 'components/tab/CustomTab'
import FormGroupWrapper from 'components/form/FormGroupWrapper'
import { utcDateTimeToLocalString } from 'helpers/dateTimeHelper'
import { localDateStringToIsoString } from 'helpers/dateTimeHelper'
import { getFullName } from 'helpers/helperFunctions'
import NotificationCountConfirmationModal from './NotificationCountModal'
import { setNotificationTab } from 'redux/slices/notificationSlice'
import { setNotificationGroup } from 'redux/slices/notificationSlice'
import { setNotificationCount } from 'redux/slices/notificationSlice'
import PredictionSelect from 'components/selects/PredictionSelect'
import PredictionCategorySelect from 'components/selects/PredictionCategorySelect'
import { toast } from 'react-toastify'
import { parseUserCsv } from '../helpers/parseUserCsv'

export const NotificationForm = ({ schedule = true }) => {
  const { state } = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [notification, setNotification] = useState(
    cloneDeep(initialNotification),
  )
  const [selectedGroup, setSelectedGroup] = useState({})
  const [selectedGender, setSelectedGender] = useState('')
  const [age, setAge] = useState(initialAge)
  const [selectedOption, setSelectedOption] = useState()
  const [ext, setExt] = useState()
  const [seoUrl, setSeoUrl] = useState({
    path: '',
    item: '',
    value: '',
  })
  const [products, setProducts] = useState({
    cart: [],
    wishlist: [],
  })
  const [cartValue, setCartValue] = useState({
    from: '',
    to: '',
  })
  const [showCountModal, setShowCountModal] = useState()
  const [selectedUserGroup, setSelectedUserGroup] = useState(userGroup[0])
  // 'search' = pick users one by one, 'csv' = bulk upload. Only one at a time.
  const [mobileInputMode, setMobileInputMode] = useState('search')

  const [predictionCampaign, setPredictionCampaign] = useState();

  const {
    product: { loading },
    redirect,
  } = useSelector((state) => state.notification)

  const isApp =
    notification.type === 'app_notification' || notification.type === 'in_app'
  const isSms = notification.type === 'sms'
  const isUpdate = schedule && !isEmpty(state)

  const _notificationTypeOptions = !isUpdate
    ? notificationTypeOptions
    : notificationTypeOptions.filter((f) => f.value === state.type)
  const _filterTypes = !isUpdate
    ? filterTypes
    : filterTypes.filter((f) => f.value === notification.filter_type)

  useEffect(() => {
    if (redirect) {
      setTabValueOnSuccess()
      setShowCountModal()
      //delay for 0 millisecond because setShowCountModal needs to close modal
      //removing this can cause scroll freeze after redirection
      setTimeout(function() {
        navigate(`/notification`)
      }, 0)
    }
  }, [redirect])

  useEffect(() => {
    if (state) {
      let gender = state?.filters?.find((f) => f?.type === 'gender')
      let age = state?.filters?.find((f) => f?.type === 'age')
      let cartValue = state?.filters?.find(
        (f) =>
          f?.type === 'cart_value' &&
          (f.hasOwnProperty('start') || f.hasOwnProperty('end')),
      )
      let extras = {}

      if (state.payload) {
        const { name, id } = getReverseFormattedSeoUrl(state.payload.link)
        extras = {
          ...(id && { id }),
          ...(name && { name }),
          notification_group: state?.payload?.notification_group,
          sub_group: state?.payload?.sub_group,
        }
      }
      if (extras?.notification_group?.length) {
        setSelectedGroup(
          groupOptions.find((o) => o.value === extras.notification_group),
        )
      }
      setNotification({
        ...notification,
        type: state?.type ?? '',
        message: state?.message ?? '',
        title: state?.title ?? '',
        notification_type: state?.notification_type ?? '',
        schedule_type: state?.schedule_type ?? '',
        repeat_method: state?.repeat_method ?? '',
        scheduled_at:
          localDateStringToIsoString(
            utcDateTimeToLocalString(state?.scheduled_at, true, false),
          ) ?? '',
        expires_at: state?.expires_at ?? '',
        extras: state?.extras ?? [],
        image_url: state?.image_url ?? '',
        action: state?.action ?? '',
        ...(!isEmpty(state.payload) && { extras }),
        filter_type: state?.filter_type
          ? state.filter_type
          : state?.mobile?.length
            ? 'number'
            : 'user',
      })
      setSelectedGender(capitalizeFirstLetter(gender?.value ?? 'All'))
      setSelectedUserGroup(!state?.filter_type ? userGroup[0] : userGroup[1])
      setAge({ toAge: age?.to, fromAge: age?.from })
      if (state.filters) {
        setExt(
          state.filters.filter(
            (f) => f.type === 'cart' || f.type === 'wishlist',
          ),
        )
      }
      setCartValue({ from: cartValue?.start, to: cartValue?.end })
    }
  }, [state])

  const setTabValueOnSuccess = () => {
    dispatch(
      setNotificationGroup(
        schedule ? notificationGroup[0] : notificationGroup[1],
      ),
    )
    if (schedule) {
      dispatch(
        setNotificationTab(
          isApp ? notificationTypeOptions[0] : notificationTypeOptions[1],
        ),
      )
    } else {
      dispatch(
        setNotificationTab(
          isSms
            ? bulkNotificationTypeOptions[0]
            : notification.action === 'push'
              ? bulkNotificationTypeOptions[2]
              : bulkNotificationTypeOptions[1],
        ),
      )
    }
  }

  const displayBrandSearch =
    (notification.extras.notification_group === 'PRODUCTS' &&
      notification.extras.sub_group === 'BRAND') ||
    (notification.extras.notification_group === 'PRODUCTS' &&
      notification.extras.sub_group === 'BRAND_WEEK') ||
    (notification.extras.notification_group === 'BRANDS' &&
      notification.extras.sub_group === 'FLASH')

  const displayProductSearch =
    notification.extras.notification_group === 'PRODUCTS' &&
    notification.extras.sub_group === 'DETAILS'

  const displayCategorySearch =
    notification.extras.notification_group === 'PRODUCTS' &&
    notification.extras.sub_group === 'CATEGORIES'

  const displayCampaignSearch =
    notification.extras.notification_group === 'CAMPAIGNS'

  const displayProductCampaignList =
    notification.extras.notification_group === 'PRODUCT_CAMPAIGNS' &&
    ['normal', 'discount'].includes(notification.extras.sub_group)

  const displayPagesList = notification.extras.notification_group === 'PAGES'

  const displayPredictionCampaign = notification.extras.notification_group === 'PREDICTIONS'

  const isFilterMobile = notification.filter_type === filterTypes[3].value
  // const isFilterAll = notification.filter_type === filterTypes[0].value
  const isFilterUserGroup = notification.filter_type === filterTypes[0].value
  const isFilterCartProducts = notification.filter_type === filterTypes[1].value
  const isFilterWishlistProducts =
    notification.filter_type === filterTypes[2].value

  const isAllFieldValid = () => {
    const isCommonValid =
      notification.title?.length > 0 && notification.message?.length > 0

    const isCartValueValid =
      cartValue?.to?.length || cartValue?.from?.length
        ? cartValue?.to?.length && cartValue?.from?.length
        : true

    const isCartValid = isFilterCartProducts
      ? products.cart?.length > 0 ||
      (cartValue?.to?.length > 0 && cartValue?.from?.length > 0)
      : true
    const isWishlistValid = isFilterWishlistProducts
      ? products.wishlist.length > 0
      : true
    const isUserFilterValid =
      isFilterUserGroup && selectedUserGroup.value === userGroup[1].value
        ? age.toAge?.length > 0 ||
        age.fromAge?.length > 0 ||
        selectedGender?.length > 0
        : true

    const isValid =
      notification.type.length > 0 &&
      notification.action.length > 0 &&
      notification.extras.notification_group.length > 0 &&
      (schedule ? notification.scheduled_at.length > 0 : true) &&
      (notification.filter_type === filterTypes[3].value
        ? notification.mobile.length > 0
        : true) &&
      (notification.schedule_type === 'RECURRING'
        ? notification.repeat_method.length
        : true) &&
      notification?.notification_type.length &&
      isCommonValid &&
      isCartValueValid &&
      isCartValid &&
      isWishlistValid &&
      isUserFilterValid

    if (isApp) {
      if (
        displayBrandSearch ||
        displayProductSearch ||
        displayCategorySearch ||
        displayCampaignSearch ||
        displayPagesList || displayPredictionCampaign
      ) {
        return (
          ((displayBrandSearch &&
            notification.extras?.id?.length > 0 &&
            notification.extras?.name?.length > 0) ||
            (displayProductSearch &&
              notification.extras?.id?.length > 0 &&
              notification.extras?.name?.length > 0) ||
            (displayCategorySearch &&
              notification.extras?.id?.length > 0 &&
              notification.extras?.name?.length > 0) ||
            (displayCampaignSearch &&
              notification.extras?.id?.length > 0 &&
              notification.extras?.name?.length > 0) ||
            (displayPredictionCampaign &&
              notification.extras?.id?.length > 0 &&
              notification.extras?.name?.length > 0) ||
            (displayPagesList &&
              notification.extras?.id?.length > 0 &&
              notification.extras?.name?.length > 0)) &&
          isValid
        )
      } else if (
        notification.extras.notification_group === 'VACCINATION' ||
        notification.extras.notification_group === 'PAGES'
      ) {
        return isValid
      } else {
        return isValid && notification.extras.sub_group?.length > 0
      }
    } else if (isSms) {
      return (
        notification.message.length > 0 &&
        (schedule ? notification.scheduled_at.length > 0 : true) &&
        (notification.filter_type === filterTypes[3].value
          ? notification.mobile.length > 0
          : true) &&
        (notification.schedule_type === 'RECURRING'
          ? notification.repeat_method.length
          : true) &&
        isCartValid &&
        isWishlistValid
      )
    }
  }

  const sendNotificationAction = () => {
    let link
    if (selectedGroup?.value === 'CAMPAIGNS') {
      link = `/brands${seoUrl?.item ? `${seoUrl.item}` : ''}`
    } else if (selectedGroup?.value === "PREDICTIONS") {
      link = `/predictions/${selectedOption.id}`
    } else {
      link = `${seoUrl?.path}${seoUrl?.item ? `${seoUrl.item}` : ''}`
    }

    let notificationPayload = {
      ...notification,
      extras: {
        ...notification.extras,
        ...(seoUrl.value !== 'VACCINATION' && { link }),
      },
      mobile: notification?.mobile?.map((u) => u.username),
      filters: [
        ...notification.filters,
        ...(products?.cart?.length
          ? [
            {
              type: 'cart',
              products: products?.cart.map((p) => ({ id: p.product_id })),
            },
          ]
          : []),
        ...(products?.wishlist?.length
          ? [
            {
              type: 'wishlist',
              products: products?.wishlist.map((p) => ({ id: p.product_id })),
            },
          ]
          : []),
        ...(cartValue?.to?.length || cartValue?.from?.length
          ? [
            {
              type: 'cart_value',
              ...(cartValue?.from?.length && { start: cartValue?.from }),
              ...(cartValue?.to.length && { end: cartValue?.to }),
            },
          ]
          : []),
      ],
    }


    if (notificationPayload.extras.sub_group === null) {
      delete notificationPayload.extras.sub_group
    }

    if (
      (notificationPayload.filter_type === filterTypes[0].value &&
        selectedUserGroup.value === userGroup[0].value) ||
      notificationPayload.filter_type === filterTypes[3].value
    ) {
      delete notificationPayload.filter_type
    }

    if (isNotEmpty(selectedGender)) {
      if (selectedGender !== 'All') {
        notificationPayload.filters.push({
          type: 'gender',
          value: selectedGender.toUpperCase(),
        })
      }
    }

    if (!isNotEmpty(notificationPayload.extras.id)) {
      delete notification.extras.id
    }
    if (!isNotEmpty(notificationPayload.extras.name)) {
      delete notification.extras.name
    }
    if (notification.type === 'sms' && notification.action.length) {
      delete notification.action
    }

    if (isSms) {
      delete notificationPayload.extras
    }

    if (!schedule) {
      delete notificationPayload.repeat_method
      delete notificationPayload.schedule_type
    }

    if (selectedUserGroup.value === userGroup[2].value) {
      notificationPayload.filters.push({
        type: "role",
        value: "GUEST"
      })
    }

    if (isNotEmpty(age.toAge) && isNotEmpty(age.fromAge)) {
      const newPayload = {
        ...notificationPayload,
        filters: notificationPayload.filters.concat({
          type: 'age',
          from: age.fromAge,
          to: age.toAge,
        }),
      }
      setShowCountModal(newPayload)
    } else {
      setShowCountModal(notificationPayload)
    }
  }

  const elementVisiblity = {
    schedulerType: schedule,
    schedulerFor:
      schedule &&
      notification.schedule_type !== undefined &&
      notification.schedule_type === 'RECURRING',
    scheduleDate: schedule,
    expiryDate: schedule && !isSms,
    allowOnlyPushWhenSchedule:
      schedule && notification.type === notificationTypeOptions[0].value,
  }

  const handleRemoveProduct = (type, product) => {
    setProducts({
      ...products,
      [type]: products[type].filter((p) => p.product_id !== product.product_id),
    })
  }

  // Switching between search and CSV clears the current selection so the two
  // input methods are never mixed.
  const switchMobileMode = (mode) => {
    if (mode === mobileInputMode) return
    setMobileInputMode(mode)
    setNotification((prev) => ({ ...prev, mobile: [] }))
  }

  const handleDownloadSampleCsv = () => {
    const sample = 'name,number\nJohn Doe,9812345678\nJane Smith,9807654321\n'
    const blob = new Blob([sample], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'notification-users-sample.csv'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const handleCsvUpload = (event) => {
    const file = event.target.files?.[0]
    // reset input so the same file can be re-selected later
    event.target.value = ''
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const { rows, errors, limitExceeded } = parseUserCsv(e.target?.result)

      if (limitExceeded) {
        toast.error(
          `CSV has ${limitExceeded.count} rows but the maximum allowed is ${limitExceeded.max} (including the column-name row).`,
        )
        return
      }

      // Report invalid numbers with their line numbers and skip the upload.
      if (errors.length) {
        const detail = errors
          .slice(0, 10)
          .map((err) =>
            err.value
              ? `Line ${err.line}: "${err.value}" — ${err.reason}`
              : `Line ${err.line}: ${err.reason}`,
          )
          .join('\n')
        const more =
          errors.length > 10 ? `\n…and ${errors.length - 10} more` : ''
        toast.error(`Invalid number(s) in CSV:\n${detail}${more}`)
        return
      }

      if (!rows.length) {
        toast.error('No valid rows found in the CSV (expected "name" and "number" columns).')
        return
      }

      const existing = notification.mobile ?? []
      const seen = new Set(existing.map((u) => u.username))
      const additions = []
      let duplicates = 0

      rows.forEach(({ name, number }) => {
        if (seen.has(number)) {
          duplicates++
          return
        }
        seen.add(number)
        additions.push({
          id: number,
          username: number,
          mobile: number,
          user_information: { first_name: name || '', last_name: '' },
        })
      })

      if (additions.length) {
        setNotification({
          ...notification,
          mobile: [...existing, ...additions],
        })
      }

      const messages = [`${additions.length} user(s) added`]
      if (duplicates) messages.push(`${duplicates} duplicate(s) skipped`)
      toast.success(messages.join(', '))
    }
    reader.onerror = () => toast.error('Could not read the CSV file.')
    reader.readAsText(file)
  }

  const resetOnFilterTypeChange = (filter) => {
    setNotification({
      ...notification,
      mobile: [],
      filters: [],
      filter_type: filter.value,
    })
    setMobileInputMode('search')
    setSelectedGender('All')
    setAge({ fromAge: '', toAge: '' })
    setCartValue({
      from: '',
      to: '',
    })
    setProducts({
      cart: [],
      wishlist: [],
    })
    dispatch(setNotificationCount())
  }

  const resetOnNotificationTypeChange = (type) => {
    setNotification({
      ...cloneDeep(initialNotification),
      type: type.value,
      action: type?.value === 'app_notification' ? 'push' : '',
    })
    setMobileInputMode('search')
    setAge({ fromAge: '', toAge: '' })
    setSelectedGender('All')
    setCartValue({
      from: '',
      to: '',
    })
    setProducts({
      cart: [],
      wishlist: [],
    })
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <NotificationFormHeader schedule={schedule} />
            <CardBody>
              <TabGroup extClass="mb-6">
                {_notificationTypeOptions.map((n) => {
                  const isDisabled = n.value === 'sms'
                  return (
                    <CustomTab
                      key={n.value}
                      onClick={() => {
                        if (isUpdate) return
                        if (isDisabled) {
                          toast.info('This service is currently unavailable.')
                          return
                        }
                        resetOnNotificationTypeChange(n)
                      }}
                      className={`py-3 flex-1 whitespace-nowrap px-9${
                        isDisabled ? ' opacity-50 cursor-not-allowed' : ''
                      }`}
                      active={notification?.type === n.value}
                    >
                      {n.label}
                    </CustomTab>
                  )
                })}
              </TabGroup>
              <div className="flex flex-col lg:flex-row sm:flex-col sm:space-y-4 md:space-y-8 md:space-x-4 xl:space-y-0 relative">
                <div className="flex-1">
                  {!isSms && (
                    <Input
                      type="text"
                      color="lightBlue"
                      size="lg"
                      placeholder="Title"
                      value={notification.title}
                      onChange={(event) =>
                        setNotification({
                          ...notification,
                          title: event.target.value,
                        })
                      }
                    />
                  )}
                  <TextArea
                    label="Message"
                    placeholder="Type Message"
                    rows="3"
                    value={notification.message}
                    limit={isSms ? smsCharacterLimit : Infinity}
                    onChange={(msg) =>
                      setNotification({
                        ...notification,
                        message: msg,
                      })
                    }
                  />
                </div>
                <div className="flex-1">
                  {!isSms && (
                    <div className="space-y-3">
                      <ImageUploadCard
                        initialImage={notification.image_url}
                        onImageUploaded={(image) => {
                          setNotification({
                            ...notification,
                            image_url: image,
                          })
                        }}
                        onImageRemoved={(image) => {
                          setNotification({
                            ...notification,
                            image_url: image,
                          })
                        }}
                      />
                      <Input
                        type="text"
                        color="lightBlue"
                        size="lg"
                        placeholder="Image Link"
                        value={notification.image_url}
                        onChange={(event) => {
                          setNotification({
                            ...notification,
                            image_url: event.target.value,
                          })
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              {isApp && (
                <FormGroupWrapper title="Link">
                  <div className="flex space-x-4">
                    <div className="flex-1">
                      <LabeledSelect
                        label="Select Category"
                        placeholder="Search Category"
                        options={categoryOptions}
                        value={
                          categoryOptions.find(
                            (o) => o.value === notification?.notification_type,
                          ) ?? ''
                        }
                        onChange={(selectedOption) =>
                          setNotification({
                            ...notification,
                            notification_type: selectedOption.value,
                          })
                        }
                      />
                    </div>
                    <div className="flex-1">
                      <LabeledSelect
                        label="Select Type"
                        placeholder="Search Type"
                        isDisabled={elementVisiblity.allowOnlyPushWhenSchedule}
                        options={typeOptions}
                        value={
                          typeOptions.find(
                            (o) => o.value === notification?.action,
                          ) ?? ''
                        }
                        onChange={(selectedOption) =>
                          setNotification({
                            ...notification,
                            action: selectedOption.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="flex space-x-4">
                    <div className="flex-1">
                      <LabeledSelect
                        label="Select Group"
                        placeholder="Search Group"
                        options={groupOptions}
                        value={
                          groupOptions.find(
                            (o) =>
                              o.value ===
                              notification?.extras?.notification_group,
                          ) ?? ''
                        }
                        onChange={(selectedOption) => {
                          setSelectedGroup(selectedOption)
                          setSelectedOption(null) // prevents Cached label from being shown
                          setPredictionCampaign()
                          setNotification({
                            ...notification,
                            extras: {
                              ...notification.extras,
                              notification_group: selectedOption.value,
                              sub_group: null,
                            },
                          })
                        }}
                      />
                    </div>
                    <div className="flex-1">
                      <LabeledSelect
                        label="Select Sub Group"
                        placeholder="Search Sub Group"
                        options={selectedGroup?.subGroupOptions}
                        isDisabled={isObjectEmpty(selectedGroup)}
                        value={
                          selectedGroup?.subGroupOptions?.find(
                            (o) => o?.value === notification?.extras?.sub_group,
                          ) ?? ''
                        }
                        onChange={(selectedOption) => {
                          setSelectedOption(null) // prevents Cached label from being shown
                          generateSeoUrl(selectedOption, true)
                          setNotification({
                            ...notification,
                            extras: {
                              ...notification.extras,
                              sub_group: selectedOption.value,
                              id: '',
                              name: '',
                            },
                          })
                        }}
                      />
                    </div>
                  </div>
                  <NotificationSelects
                    notification={notification}
                    generateSeoUrl={generateSeoUrl}
                    setNotification={setNotification}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                    displayBrandSearch={displayBrandSearch}
                    displayProductSearch={displayProductSearch}
                    displayCategorySearch={displayCategorySearch}
                    displayCampaignSearch={displayCampaignSearch}
                    displayProductCampaignList={displayProductCampaignList}
                    displayPagesList={displayPagesList}
                  />
                  {displayPredictionCampaign &&
                    <div className="flex flex-row space-x-4">
                      <PredictionSelect
                        value={predictionCampaign} onChange={(v) => {
                          setSelectedOption()
                          setPredictionCampaign(v)
                        }} />
                      <PredictionCategorySelect
                        campaignId={predictionCampaign?.id}
                        value={selectedOption} onChange={(v) => {
                          setSelectedOption(v)
                          generateSeoUrl(v);
                          setNotification({
                            ...notification,
                            extras: {
                              ...notification.extras,
                              name: v.title,
                              id: `${v.id}`,

                            }
                          })
                        }} />

                    </div>

                  }
                </FormGroupWrapper>
              )}

              {elementVisiblity.schedulerType && (
                <FormGroupWrapper title="Schedule">
                  <div className="flex space-x-4">
                    {elementVisiblity.scheduleDate && (
                      <div className="flex-1">
                        <DateTimePicker
                          name="Date"
                          label="Scheduled Date"
                          isRequired={true}
                          selectedDate={notification?.scheduled_at ?? ''}
                          disabled={isUpdate}
                          onChange={(value) => {
                            setNotification({
                              ...notification,
                              scheduled_at: value,
                            })
                          }}
                        />
                      </div>
                    )}
                    <div className="flex-1 space-y-6">
                      {elementVisiblity.schedulerType && (
                        <div>
                          {/*Schedule Type*/}
                          <RadioGroup label="Scheduled Type">
                            {['RECURRING', 'NON_RECURRING'].map((type) => {
                              return (
                                <RadioItem
                                  disabled={isUpdate}
                                  key={type}
                                  name="Scheduler Type"
                                  label={capitalizeAndRemoveUnderscore(type)}
                                  value={notification.schedule_type}
                                  isChecked={
                                    notification.schedule_type === type
                                  }
                                  onChanged={() =>
                                    setNotification({
                                      ...notification,
                                      schedule_type: type,
                                      repeat_method: '',
                                    })
                                  }
                                />
                              )
                            })}
                          </RadioGroup>
                        </div>
                      )}
                      {/*Schedule selection section*/}
                      {elementVisiblity.schedulerFor && (
                        <RadioGroup label="Scheduled For">
                          {['DAILY', 'MONTHLY', 'YEARLY'].map((type) => {
                            return (
                              <RadioItem
                                key={type}
                                name="Scheduler For"
                                label={type}
                                value={notification.repeat_method}
                                isChecked={notification.repeat_method === type}
                                onChanged={() =>
                                  setNotification({
                                    ...notification,
                                    repeat_method: type,
                                  })
                                }
                              />
                            )
                          })}
                        </RadioGroup>
                      )}
                    </div>
                  </div>
                </FormGroupWrapper>
              )}

              <FormGroupWrapper title="Target">
                <TabGroup extClass="mb-6">
                  {(schedule
                    ? _filterTypes.filter((v) => v.value !== 'number')
                    : _filterTypes
                  ).map((filter) => {
                    return (
                      <CustomTab
                        key={filter.value}
                        onClick={() => {
                          if (!isUpdate) {
                            resetOnFilterTypeChange(filter)
                          }
                        }}
                        className="py-3 flex-1 whitespace-nowrap px-9"
                        active={notification.filter_type === filter.value}
                      >
                        {filter.label}
                      </CustomTab>
                    )
                  })}
                </TabGroup>
                {isFilterMobile ? (
                  <>
                    <div className="mb-6">
                      <div className="mb-4">
                        <RadioItem
                          value="search"
                          label="Search & Select"
                          isChecked={mobileInputMode === 'search'}
                          onChanged={() => switchMobileMode('search')}
                          className="font-medium"
                        />
                        <div className="mt-1 text-sm ml-7">
                          Search users by phone number and add them one by one.
                        </div>
                      </div>
                      <div>
                        <RadioItem
                          value="csv"
                          label="Upload CSV"
                          isChecked={mobileInputMode === 'csv'}
                          onChanged={() => switchMobileMode('csv')}
                          className="font-medium"
                        />
                        <div className="mt-1 text-sm ml-7">
                          Add many users at once from a CSV file.
                        </div>
                      </div>
                    </div>
                    {mobileInputMode === 'search' ? (
                      <>
                        <div className="w-1/2">
                          <UserInfoSearchSelect
                            label="Add Users"
                            isMin={true}
                            placeholder="Search By Phone Number"
                            onChange={(user) => {
                              if (
                                !notification.mobile.some(
                                  (v) => v.username === user.username,
                                )
                              ) {
                                setNotification({
                                  ...notification,
                                  mobile: [...notification.mobile, user],
                                })
                              }
                            }}
                          />
                        </div>
                        <div className="flex flex-wrap">
                          {notification?.mobile?.map((user) => (
                            <Chip
                              key={user.mobile}
                              label={`${getFullName(user.user_information)} | ${user.username
                                }`}
                              onClick={() =>
                                setNotification({
                                  ...notification,
                                  mobile: notification?.mobile.filter(
                                    (m) => m.username !== user.username,
                                  ),
                                })
                              }
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <label className="inline-flex items-center px-4 py-2 text-sm font-medium text-white rounded cursor-pointer bg-secondary-500 hover:bg-secondary-600 whitespace-nowrap">
                            Upload CSV
                            <input
                              type="file"
                              accept=".csv,text/csv"
                              className="hidden"
                              onChange={handleCsvUpload}
                            />
                          </label>
                          <p className="mt-1 text-xs text-gray-400">
                            Columns: name, number &middot;{' '}
                            <button
                              type="button"
                              onClick={handleDownloadSampleCsv}
                              className="underline text-secondary-600 hover:text-secondary-700"
                            >
                              Download sample
                            </button>
                          </p>
                        </div>
                        {notification?.mobile?.length > 0 && (
                          <div className="flex items-center gap-3 mt-4 text-sm">
                            <span className="font-medium text-gray-700">
                              {notification.mobile.length} number(s) selected
                            </span>
                            <button
                              type="button"
                              onClick={() =>
                                setNotification({ ...notification, mobile: [] })
                              }
                              className="underline text-error-600 hover:text-error-700"
                            >
                              Clear
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : isFilterUserGroup ? (
                  <>
                    {!(
                      isUpdate && selectedUserGroup.value !== userGroup[0].value
                    ) && (
                        <div className="mb-6">
                          <RadioItem
                            value={selectedUserGroup.value}
                            label="All Users"
                            isChecked={
                              selectedUserGroup.value === userGroup[0].value
                            }
                            onChanged={() => {
                              setSelectedUserGroup(userGroup[0])
                              resetOnFilterTypeChange(_filterTypes[0])
                            }}
                            className="font-medium"
                            showRadioButton={
                              !(
                                isUpdate &&
                                selectedUserGroup.value === userGroup[0].value
                              )
                            }
                          />
                          <div className="ml-7 mt-1 text-sm">
                            Notification will be sent to all users.
                        </div>
                        </div>
                      )}
                    {!(isUpdate && selectedUserGroup.value !== userGroup[2].value) &&
                      <div className="mb-4">
                        <RadioItem
                          value={selectedUserGroup.value}
                          label="Guest Users"
                          isChecked={
                            selectedUserGroup.value === userGroup[2].value
                          }
                          onChanged={() => {
                            setSelectedUserGroup(userGroup[2])
                            resetOnFilterTypeChange(_filterTypes[0])
                            setSelectedGender('')
                          }}
                          showRadioButton={
                            !(
                              isUpdate &&
                              selectedUserGroup.value === userGroup[2].value
                            )
                          }
                          className="font-medium"
                        />
                        <div className="ml-7 mt-1 text-sm">
                          All users currently not logged in to the app will receive this notification.
                        </div>
                      </div>

                    }
                    {!(
                      isUpdate && selectedUserGroup.value !== userGroup[1].value
                    ) && (
                        <div className="mb-4">
                          <RadioItem
                            value={selectedUserGroup.value}
                            label="User Group"
                            isChecked={
                              selectedUserGroup.value === userGroup[1].value
                            }
                            onChanged={() => {
                              setSelectedUserGroup(userGroup[1])
                              resetOnFilterTypeChange(_filterTypes[0])
                              setSelectedGender('All')
                            }}
                            showRadioButton={
                              !(
                                isUpdate &&
                                selectedUserGroup.value === userGroup[1].value
                              )
                            }
                            className="font-medium"
                          />
                          <div className="ml-7 mt-1 text-sm">
                            Only specified user group will receive this
                            notification.
                        </div>
                        </div>
                      )}


                    {/* User Group */}
                    <div
                      className={`flex space-x-8 ml-7 transition-all overflow-hidden ${selectedUserGroup.value !== userGroup[1].value
                        ? 'h-0'
                        : 'h-[86px]'
                        }`}
                    >
                      <div className="flex-1 space-y-2">
                        <FormLabel label="Age Group" isRequired={false} />
                        <div className="flex space-x-4 items-center">
                          <Input
                            type="number"
                            placeholder="From"
                            value={age.fromAge}
                            postIcon="years"
                            hasLabel={false}
                            onChange={(event) => {
                              if (event.target.value.length < 4) {
                                setAge({
                                  ...age,
                                  fromAge: event.target.value,
                                })
                              }
                            }}
                          />
                          <span className="mb-5 font-bold text-lg">-</span>
                          <Input
                            type="number"
                            placeholder="To"
                            value={age.toAge}
                            postIcon="years"
                            hasLabel={false}
                            onChange={(event) => {
                              if (event.target.value.length < 4) {
                                setAge({ ...age, toAge: event.target.value })
                              }
                            }}
                          />
                        </div>
                      </div>

                      {/*Gender selection section*/}
                      <div className="flex-1">
                        <RadioGroup label="Gender">
                          {['All', 'Male', 'Female'].map((gender) => {
                            return (
                              <RadioItem
                                key={gender}
                                name="gender"
                                label={gender}
                                value={selectedGender}
                                isChecked={selectedGender === gender}
                                onChanged={() => setSelectedGender(gender)}
                              />
                            )
                          })}{' '}
                        </RadioGroup>
                      </div>
                    </div>
                  </>
                ) : isFilterCartProducts ? (
                  <div>
                    <div className="mb-3">
                      <ProductSelector
                        products={products}
                        setProducts={setProducts}
                        type={productListType.cart}
                        data={products?.cart}
                        ext={ext}
                      />
                      <ProductViewer
                        data={products?.cart ?? []}
                        type={'cart'}
                        onRemove={handleRemoveProduct}
                        loading={loading}
                      />
                    </div>
                    <div className="w-1/2">
                      <FormLabel label="Cart Value" />
                      <div className="flex space-x-4">
                        <div className="flex space-x-1.5">
                          <span className="text-sm mt-2.5">Min</span>
                          <Input
                            type="number"
                            placeholder="0"
                            hasLabel={false}
                            value={cartValue?.from}
                            preIcon="NPR. "
                            onChange={(event) => {
                              setCartValue({
                                ...cartValue,
                                from: event.target.value,
                              })
                            }}
                          />
                        </div>
                        <div className="flex space-x-1.5">
                          <span className="text-sm mt-2.5">Max</span>
                          <Input
                            type="number"
                            placeholder="0"
                            hasLabel={false}
                            value={cartValue?.to}
                            preIcon="NPR. "
                            onChange={(event) => {
                              setCartValue({
                                ...cartValue,
                                to: event.target.value,
                              })
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <ProductSelector
                      type={productListType.wishlist}
                      data={products?.cart}
                      setProducts={setProducts}
                      ext={ext}
                      products={products}
                    />
                    <ProductViewer
                      data={products?.wishlist ?? []}
                      type={'wishlist'}
                      onRemove={handleRemoveProduct}
                      loading={loading}
                      isCartItem={false}
                    />
                  </div>
                )}
              </FormGroupWrapper>
              <div className="flex space-x-5">
                <SecondaryButton
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="mt-10 ml-auto"
                >
                  Cancel
                </SecondaryButton>

                <CustomButton
                  onClick={sendNotificationAction}
                  className="mt-10 ml-auto"
                  disabled={!isAllFieldValid()}
                >
                  {`${isUpdate ? 'Update' : `${schedule ? 'Schedule' : 'Send'}`
                    } Notification`}
                </CustomButton>
              </div>
            </CardBody>
          </CustomCard>
        </div>
      </div>
      <NotificationCountConfirmationModal
        onConfirm={scheduleOrBroadcastNotification}
        showModal={showCountModal}
        setShowModal={setShowCountModal}
        isSchedule={schedule}
      />
    </div>
  )

  function generateSeoUrl(selectedOption, fromSubGroup = false) {
    if (selectedOption?.seoUrl && fromSubGroup) {
      setSeoUrl({
        path: selectedOption.seoUrl ?? '',
        value: selectedOption.value,
      })
    } else {
      setSeoUrl({
        ...seoUrl,
        item: `/${getFormattedSeoUrl({
          id: selectedOption?.id ?? selectedOption?.product_id,
          title: selectedOption?.title ?? selectedOption?.name,
          seoDetails: selectedOption?.seo_details,
        })}`,
      })
    }
  }

  function scheduleOrBroadcastNotification(payload) {
    if (schedule) {
      if (isUpdate) {
        dispatch(
          tryUpdateScheduleNotification(
            removeKeysFromObjectWithEmptyOrNullOrUndefinedValue({
              id: state.id,
              payload,
            }),
          ),
        )
      } else {
        dispatch(
          tryScheduleNotification(
            removeKeysFromObjectWithEmptyOrNullOrUndefinedValue(payload),
          ),
        )
      }
    } else {
      if (payload?.mobile?.length) {
        dispatch(
          broadcastNotification(
            removeKeysFromObjectWithEmptyOrNullOrUndefinedValue({ payload }),
          ),
        )
      } else {
        dispatch(
          broadcastNotification(
            removeKeysFromObjectWithEmptyOrNullOrUndefinedValue({
              payload,
              isUserNotification: true,
            }),
          ),
        )
      }
    }
  }
}

const NotificationFormHeader = ({ schedule }) => {
  return (
    <CustomCardHeader contentPosition="none">
      <div className="flex items-center w-full space-x-4">
        <div className="w-full">
          <div className="flex justify-between">
            <h2 className="text-2xl text-white">
              {schedule ? 'Schedule New Notification' : 'Send New Notification'}
            </h2>
          </div>
          <div className="text-rand-100"></div>
        </div>
      </div>
    </CustomCardHeader>
  )
}

export default NotificationForm
